// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kefuAdjustRules .Dia_title[data-v-20005a55] {\n  font-weight: bold;\n  color: #333333;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
